module.exports = __webpack_public_path__ + "img/8a.12cdb3bc.png";